import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { api } from '../api';
import { WindowInfo } from '../types/window';


const initialState: WindowInfo = {
  stepTotal: 2,
  stepCurrent: 0,
  loaderWindow: true,
  loaderButton: false,
  checkoutMsg: '',
  globalMsg: ''
};

const windowInfo = createSlice({
  name: 'window',
  initialState,
  reducers: {
    changeStep(state, action: PayloadAction<number>) {

        if(action.payload === 4) {
          state.stepCurrent = 4;
        } else if(action.payload === 1) {
          if(state.stepCurrent + 1 <= state.stepTotal) {
            state.stepCurrent++;
          }
        } else {
          if(state.stepCurrent > 0) {
            state.stepCurrent--;
          }
        }
    },
    isMainLoader(state, action: PayloadAction<boolean>) {
      state.loaderWindow = action.payload;
    },
    isButtonLoader(state, action: PayloadAction<boolean>) {
      state.loaderButton = action.payload;
    },
    setCheckoutMsg(state, action: PayloadAction<string>) {
      state.checkoutMsg = action.payload;
    },
    setGlobalMsg(state, action: PayloadAction<string>) {
      state.globalMsg = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
    .addMatcher(
      api.endpoints.updateProducts.matchFulfilled,
      (state, { payload }) => {
        if(payload.response === 'ok') {
          state.loaderButton = false;
          if(state.stepCurrent + 1 <= state.stepTotal) {
            state.stepCurrent++;
          }
        } else {
          state.loaderButton = false;
          state.stepCurrent++;
        }
      }
    )
  },
});

export const { changeStep, isMainLoader, isButtonLoader, setCheckoutMsg, setGlobalMsg } = windowInfo.actions;
export default windowInfo.reducer;